import { useSnackbar } from "notistack";
import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { Panel } from "primereact/panel";

import { useCreateSecretaria1Mutation, useCreateSecretariaMutation, useGetSecretariaQuery, useUpdateSecretariaMutation } from "./SecretariaApiSlice";
import errorFormat from "../../utils/errorFormat";
import { useParams } from "react-router-dom";
import { errorMonitor } from "events";
import { useNavigate } from "react-router-dom";
import configUrls from "../../config/configUrls";
import { ISsecretaria, Secretaria } from "../../types/secretaria/Secretaria";
import { SecretariaForm } from "./SecretariaForm";
import { Orgao } from "../../types/orgao/Orgao";
import { useSecretariaRoutes } from "../../config/useSecretariaRoutes";





export const SecretariaEdit = () => {

    const secretariaRoutes=useSecretariaRoutes();
    const navigate = useNavigate();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()


    const [updateSecretaria, status] = useUpdateSecretariaMutation();


    const id = useParams().id || "";
    const { data, isFetching, error } = useGetSecretariaQuery(id);
    const [secretaria, setSecretaria] = useState<Secretaria>(ISsecretaria);


    useEffect(() => {
        if (data) {
            setSecretaria(data);
        } else if (error) {
            enqueueSnackbar("Registro não encontrado!", { variant: "error" })
        } else if (isFetching) {
            enqueueSnackbar("Buscando registro...", { variant: "info" })
        } else {
            enqueueSnackbar("Registro não encontrado!", { variant: "error" })
        }
    }, [data, error, isFetching])



    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setSecretaria((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };
    const handleCepChange = (newCep: string) => {
        // Aqui você pode atualizar o estado com o novo valor de CEP
        setSecretaria((prev) => ({
            ...prev,
            cep: newCep,
        }));
    };
    const handleSearchOrgaoChange = (parOrgao: Orgao | null) => {
        setSecretaria((prev) => ({
            ...prev,
            orgao: parOrgao ? {
                ...prev.orgao,
                id: parOrgao.id || "",
                nome: parOrgao.nome || "",

            } : null // Se parOrgao for null, deixa o orgao como null
        }));
    };

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        await updateSecretaria(secretaria);
    }

    useEffect(() => {
        if (status.isError) {
            enqueueSnackbar("Registro não alterado!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro alterado com sucesso!", { variant: "success" })
            navigate(secretariaRoutes.SECRETARIA_LIST);
        }
    }, [status]);


    return (
        <>
            <Paper >

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Secretaria de Governo- Edição
                </Typography>



                <SecretariaForm
                    data={secretaria}
                    // isdisabled={status.isLoading}
                    //isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                    handleCepChange={handleCepChange}
                    handleSearchOrgaoChange={handleSearchOrgaoChange}
                />
            </Paper>










        </>







    );










};

/*
 <SecretariaTurmaForm
                    secretariaTurma={secretariaTurmaState}
                    isdisabled={status.isLoading}
                    isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
*/